export const reportContentButtonContainerCss = {
  display: "flex",
  justifyContent: "center",
  marginTop: "8px",
  marginBottom: "32px",
};

export const reportContentButtonCss = {
  padding: "8px",
};
